import * as React from "react";
import { motion } from "framer-motion";
import { MarkdownRenderer } from "@/components/feature/markdown/markdownRenderer";
import { OpenChatMessage } from "@/types/open-chat";
import { OpenChatIcon } from "@/views/open-chat/components/openChatIcon";

import * as S from "./messageRowAi.styled";
import { OpenChatMessageRowCopy } from "./messageRowCopy";
import { OpenChatMessageRowImprovementEditor } from "./messageRowImprovementEditor";
import clsx from "clsx";

interface Props {
  message: OpenChatMessage;
  allowCopy?: boolean;
  isImprovement?: boolean;
  hideIcons?: boolean;
}

export const OpenChatMessageRowAi: React.FC<Props> = ({ hideIcons, message, allowCopy, isImprovement }) => {
  const [editedImprovedPrompt, setEditedImprovedPrompt] = React.useState<string>();
  const [isEdit, setIsEdit] = React.useState(false);

  return (
    <motion.div
      className="my-3 flex justify-start"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ type: "spring", stiffness: 500, damping: 30, mass: 1 }}
    >
      <div className="flex w-full">
        {!hideIcons && (
          <div className="mr-2">
            <OpenChatIcon width={16} height={16} />
          </div>
        )}
        <motion.div
          className="w-full"
          initial={{ scale: 0.95, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.1, duration: 0.3 }}
        >
          <S.Container
            className={clsx("w-full rounded-md p-5 text-sm", {
              "whitespace-pre-wrap border-2 border-gray-500": isEdit,
            })}
            contentEditable={isEdit}
            onBlur={t => {
              setEditedImprovedPrompt(t.currentTarget.innerHTML);
            }}
          >
            {isEdit ? (
              editedImprovedPrompt || message.content
            ) : (
              <MarkdownRenderer
                content={editedImprovedPrompt || message.content}
                evidences={[]}
                processCitations={false}
              />
            )}
          </S.Container>

          {message.completed && (
            <>
              {allowCopy && message.completed && (
                <OpenChatMessageRowCopy content={editedImprovedPrompt || message.content} />
              )}
              {isImprovement && (
                <OpenChatMessageRowImprovementEditor
                  setIsEdit={setIsEdit}
                  content={editedImprovedPrompt || message.content}
                />
              )}
            </>
          )}
        </motion.div>
      </div>
    </motion.div>
  );
};
